import { ApiService } from '../../common'

export class AppSocksApi extends ApiService {}
